import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();
  const year = new Date().getFullYear();

  return (
    <footer className="bg-secondary-100 border-t border-secondary-200/60 relative overflow-hidden">
      {/* Decorative sushi pattern on right side */}
      <img
        src="https://readdy.ai/api/search-image?query=Elegant%20traditional%20Japanese%20sushi%20restaurant%20decorative%20pattern%20concentrated%20on%20right%20side%2C%20subtle%20nigiri%20sushi%20and%20cherry%20blossom%20silhouettes%20with%20traditional%20seigaiha%20wave%20and%20asanoha%20hemp%20leaf%20geometric%20pattern%2C%20warm%20beige%20and%20soft%20gold%20brown%20tones%20on%20light%20cream%20background%2C%20minimal%20sophisticated%20design%20with%20empty%20left%20space%20for%20text%2C%20traditional%20Japanese%20aesthetic%20artwork%2C%20high%20quality%20illustration&width=1200&height=600&seq=footer-pattern-v1&orientation=landscape"
        alt=""
        className="absolute right-0 top-0 h-full w-1/2 md:w-1/3 object-cover object-right opacity-15 pointer-events-none hidden md:block"
      />
      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-8 items-start">
          {/* Brand */}
          <div className="flex items-start">
            <Link to="/" className="block [writing-mode:vertical-rl] tracking-wider">
              <p className="font-heading text-xs tracking-[0.3em] text-foreground-500 mb-2">{t('hero_subtitle')}</p>
              <p className="font-calligraphy text-3xl md:text-4xl text-foreground-900 leading-tight">{t('hero_title')}</p>
            </Link>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="text-xs tracking-widest text-foreground-400 mb-4 font-label">
              {t('footer_nav_title')}
            </h4>
            <div className="flex flex-col gap-2">
              <Link to="/" className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors whitespace-nowrap">
                {t('footer_nav_home')}
              </Link>
              <Link to="/menu" className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors whitespace-nowrap">
                {t('footer_nav_menu')}
              </Link>
              <Link to="/about" className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors whitespace-nowrap">
                {t('footer_nav_about')}
              </Link>
              <Link to="/access" className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors whitespace-nowrap">
                {t('footer_nav_access')}
              </Link>
              <Link to="/reservation" className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors whitespace-nowrap">
                {t('footer_nav_reservation')}
              </Link>
            </div>
          </div>

          {/* Info */}
          <div>
            <h4 className="text-xs tracking-widest text-foreground-400 mb-4 font-label">{t('footer_info_title')}</h4>
            <div className="space-y-3 text-sm text-foreground-600">
              <p className="whitespace-pre-line">
                {t('footer_address')}
              </p>
              <p>
                <a href="tel:03-3980-5537" className="hover:text-foreground-900 transition-colors">
                  {t('footer_tel')}
                </a>
              </p>
              <div className="flex flex-col gap-1 text-xs">
                <p>{t('footer_hours_lunch')}</p>
                <p>{t('footer_hours_dinner')}</p>
                <p>{t('footer_closed')}</p>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-secondary-200/60 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-400">
            {t('footer_copyright').replace('{{year}}', String(year))}
          </p>
          <div className="flex items-center gap-4">
            <a href="https://x.com/takazusi_ikeb96" target="_blank" rel="noopener noreferrer" className="text-foreground-400 hover:text-foreground-600 transition-colors" aria-label="X（旧Twitter）">
              <i className="ri-twitter-x-fill text-lg" />
            </a>
            <a href="https://www.instagram.com/" target="_blank" rel="noopener noreferrer" className="text-foreground-400 hover:text-foreground-600 transition-colors" aria-label="Instagram">
              <i className="ri-instagram-line text-lg" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}